import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactS3Uploader from 'react-s3-uploader';
import cn from 'classnames';

import { useAuthHeaders } from '@loyalup/core';

import s from './FileUploader.module.css';

const onPreprocess = (file, next, onStart) => {
  onStart && onStart();
  next(file);
};

const FileUploader = forwardRef(({ server, accept, type, onStart, onFinish, hidden }, ref) => {
  const inputRef = useRef();
  const headers = useAuthHeaders();

  useImperativeHandle(ref, () => ({
    selectFile: () => {
      inputRef.current.click();
    },
  }));

  return (
    <ReactS3Uploader
      className={cn(s.root, { [s.hidden]: hidden })}
      signingUrl={`/rest/storage/upload_url/${type}`}
      accept={accept}
      server={server}
      preprocess={(file, next) => onPreprocess(file, next, onStart)}
      onFinish={({ path }, { name }) => onFinish({ path, filename: name })}
      uploadRequestHeaders={{}}
      signingUrlHeaders={headers}
      inputRef={ref => (inputRef.current = ref)}
    />
  );
});

FileUploader.propTypes = {
  accept: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['csv', 'userpic', 'pass_images']).isRequired,
  onStart: PropTypes.func,
  onFinish: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  server: PropTypes.string.isRequired,
};

FileUploader.defaultProps = {
  hidden: false,
};

export default FileUploader;
